import React from "react";
import { connect } from "react-redux";
import utils from "utils";

export const NavTitle = (props) => {
  const { headerNavColor } = props;

  return (
    <div
      style={{
        position: "absolute",
        top: 18,
        left: 50,
        width: "85%",
        height: 70,
        textAlign: "center",
      }}
    >
    </div>
  );
};

const mapStateToProps = ({ theme }) => {
  const { headerNavColor } = theme;
  return { headerNavColor };
};

export default connect(mapStateToProps, {})(NavTitle);
